import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ChecklistPage } from './pages';

const ChecklistFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ChecklistPage /> } />
    </Routes>
  );
};

export default ChecklistFeature;